import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { Textarea } from "../ui/textarea";
import { Wallet } from "lucide-react";
import { INCASSO_OPTIONS, PAGAMENTO_OPTIONS } from "../../lib/options";
import { SEZ, Field, Sel } from "./fields";

export const oreFM = (arrivo, ripartenza) => {
  if (!arrivo || !ripartenza) return "";
  const [ah, am] = arrivo.split(":").map(Number);
  const [rh, rm] = ripartenza.split(":").map(Number);
  if ([ah, am, rh, rm].some(isNaN)) return "";
  let diff = rh * 60 + rm - (ah * 60 + am);
  if (diff < 0) diff += 24 * 60;
  return `${Math.floor(diff / 60)}h ${String(diff % 60).padStart(2, "0")}m`;
};

export const feeNexus = (importo) => {
  const n = parseFloat(String(importo ?? "").replace(",", "."));
  return isNaN(n) ? "" : (n * 0.15).toFixed(2);
};

export const ContabilitaSection = ({ contabilita, setContabilita, distanzaKm, setDistanzaKm }) => {
  const upd = (k) => (v) => setContabilita({ ...contabilita, [k]: v });
  const updImporto = (v) => setContabilita({ ...contabilita, importo: v, fee_nexus: feeNexus(v) });
  return (
    <SEZ icon={Wallet} title="Contabilità e Note">
      <Field label="Importo Servizio (€)" value={contabilita.importo} onChange={updImporto} testid="con-importo" />
      <Field label="Importo Totale (€)" value={contabilita.importo_totale} onChange={upd("importo_totale")} testid="con-importo-totale" />
      <Sel label="Modalità Pagamento" value={contabilita.modalita_pagamento} onChange={upd("modalita_pagamento")} options={PAGAMENTO_OPTIONS} testid="con-pagamento" />
      <Sel label="Incasso" value={contabilita.incasso} onChange={upd("incasso")} options={INCASSO_OPTIONS} testid="con-incasso" />
      <div className="md:col-span-2 md:w-1/2 md:pr-2">
        <Field label="Fee Nexus (€) — auto 15%" value={contabilita.fee_nexus} onChange={upd("fee_nexus")} testid="con-fee" />
      </div>
      <Field label="Distanza Tratta (km)" value={distanzaKm} onChange={setDistanzaKm} testid="con-distanza-km" placeholder="Auto da Google Maps" />
      <Field label="KM Manuali" type="number" value={contabilita.km_manuali} onChange={upd("km_manuali")} testid="con-km-manuali" placeholder="es. 42" />
      <Field label="Ora Arrivo" type="time" value={contabilita.ora_arrivo} onChange={upd("ora_arrivo")} testid="con-ora-arrivo" />
      <Field label="Ora Ripartenza" type="time" value={contabilita.ora_ripartenza} onChange={upd("ora_ripartenza")} testid="con-ora-ripartenza" />
      <div className="md:col-span-2 md:w-1/2 md:pr-2">
        <Label className="nx-label">Ore FM (calcolato)</Label>
        <Input data-testid="con-ore-fm" readOnly value={oreFM(contabilita.ora_arrivo, contabilita.ora_ripartenza)} placeholder="—" className="mt-1.5 bg-slate-50 font-semibold" />
      </div>
      <div className="md:col-span-2">
        <Label className="nx-label">Note Operative</Label>
        <Textarea data-testid="con-note" value={contabilita.note} onChange={(e) => setContabilita({ ...contabilita, note: e.target.value })} className="mt-1.5" rows={3} />
      </div>
    </SEZ>
  );
};
